export default "__VITE_ASSET__BNJsRR8$__"